import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonServiceService } from '../../common-service.service';
import * as moment from 'moment-timezone';
import { Router } from '@angular/router';
import { GlobalVariable } from '../../global-variable';
@Component({
  selector: 'app-gds-sync-log-search',
  templateUrl: './gds-sync-log-search.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class GdsSyncLogSearchComponent implements OnInit {

  modalRef: BsModalRef;
  clientFilterForm: FormGroup;
  clientArr: any;
  keyword = 'name';
  countryArr: any = [];
  stateArr: any = [];
  cityArr: any = [];
  @ViewChild('clientAC',{static:true}) clientAC;
  @ViewChild('searchButton',{static:true}) searchButton : ElementRef;

  dateFormat = 'YYYY-MM-DD';
  isLocaleDateFormat: boolean = true;
  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    public commonService: CommonServiceService,
    private spinner: NgxSpinnerService,
    private router: Router) {
  }

  ngOnInit() {

    // this.spinner.show();
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 1000);


    this.clientFilterForm = this.formBuilder.group({
      filename: [''],
      gds: [''],
      status: [''],
      start_dat: [''],
      end_date: ['']
    })
    this.setFormData()
    this.getGlobalSettingsFormattedDate()
  }

  async setFormData() {
    let queryParams = localStorage.getItem('activeGDSSyncLogsQueryParams')
    if (queryParams != null) {
      let parsedParams = JSON.parse(queryParams)
     
      this.clientFilterForm.controls.filename.setValue(parsedParams.filename ? parsedParams.filename : "")
      this.clientFilterForm.controls.gds.setValue(parsedParams.gds ? parsedParams.gds : "")
      this.clientFilterForm.controls.status.setValue(parsedParams.status ? parsedParams.status : "")
      if (parsedParams.start_date != "") {
        this.clientFilterForm.controls.start_date.setValue(moment(parsedParams.start_date).format('YYYY-MM-DD'))
      }
      if (parsedParams.end_date != "") {
        this.clientFilterForm.controls.end_date.setValue(moment(parsedParams.end_date).format('YYYY-MM-DD'))
      }
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'customModal' })
    );
  }


  reset() {
    GlobalVariable.openModalStatus = false;
    this.clientFilterForm = this.formBuilder.group({
      filename: [''],
      gds: [''],
      status: [''],
      start_dat: [''],
      end_date: ['']
    })
    
    localStorage.removeItem('activeGDSSyncLogsQueryParams')

  }

  search(values) {
    GlobalVariable.openModalStatus = false;
    if ((values.start_date == null || values.start_date == "" || values.start_date == "Invalid date" || values.start_date == "Invalid date") ) {
          values.start_date = ""
    }
    else{
      values.start_date = moment(values.start_date).format('YYYY-MM-DD')
    }
    if ((values.end_date == null || values.end_date == "" || values.end_date == "Invalid date" || values.end_date == "Invalid date")) {
      values.end_date = ""
    }
    else{
      values.end_date = moment(values.end_date).format('YYYY-MM-DD')
    }
   
    this.router.navigateByUrl(`utilities/gds-sync-logs?start_date=${values.start_date}&end_date=${values.end_date}&gds=${values.gds}&status=${values.status}&filename=${values.filename}`)
    // this.reset()
  }

  

  clickSearchButton(){
    this.searchButton.nativeElement.click()
  }

  async getGlobalSettingsFormattedDate() {
		let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}

		let dateConfig = await this.commonService.getDateFormat('date_format')
		this.dateFormat = dateConfig.dateFormat
		this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
	}

}
